const animation = {
  v: "5.9.0",
  fr: 60,
  ip: 0,
  op: 360,
  w: 320,
  h: 320,
  nm: "spinnerDarkLG",
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Rectangle 2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.842], y: [0.557] },
              o: { x: [0.151], y: [0.321] },
              t: 195,
              s: [0],
            },
            { t: 290, s: [-360] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [107, 109, 0], ix: 2, l: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 50, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [50, 50], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.117647058824, 0.160784313725, 0.23137254902, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [46, 90], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.479, 0.479], y: [0.879, 0.879] },
                    o: { x: [0.033, 0.033], y: [0.178, 0.178] },
                    t: 195,
                    s: [0, 0],
                  },
                  {
                    i: { x: [0.837, 0.837], y: [12.278, 12.278] },
                    o: { x: [0.277, 0.277], y: [22.912, 22.912] },
                    t: 213,
                    s: [116.694, 116.694],
                  },
                  {
                    i: { x: [0.913, 0.913], y: [0.759, 0.759] },
                    o: { x: [0.542, 0.542], y: [0.128, 0.128] },
                    t: 268,
                    s: [116.694, 116.694],
                  },
                  { t: 290, s: [0, 0] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transformer ",
            },
          ],
          nm: "Rectangle 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 180,
      op: 300,
      st: 180,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Triangle 2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.527], y: [1] },
              o: { x: [0.494], y: [0] },
              t: 189,
              s: [0],
            },
            { t: 300, s: [360] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [105, 217, 0], ix: 2, l: 2 },
        a: { a: 0, k: [-131, 107, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "sr",
              sy: 2,
              d: 1,
              pt: { a: 0, k: 3, ix: 3 },
              p: { a: 0, k: [0, 0], ix: 4 },
              r: { a: 0, k: 90, ix: 5 },
              or: { a: 0, k: 28, ix: 7 },
              os: { a: 0, k: 0, ix: 9 },
              ix: 1,
              nm: "Polystar Path 1",
              mn: "ADBE Vector Shape - Star",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.117647058824, 0.160784313725, 0.23137254902, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [-75.3, 72.9], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.815, 0.815], y: [0.96, 0.96] },
                    o: { x: [0.102, 0.102], y: [0.243, 0.243] },
                    t: 197,
                    s: [0, 0],
                  },
                  {
                    i: { x: [0.847, 0.847], y: [0.448, 0.448] },
                    o: { x: [0.307, 0.307], y: [-0.738, -0.738] },
                    t: 221,
                    s: [130, 130],
                  },
                  {
                    i: { x: [0.855, 0.855], y: [0.814, 0.814] },
                    o: { x: [0.546, 0.546], y: [0.219, 0.219] },
                    t: 262,
                    s: [110, 110],
                  },
                  { t: 287, s: [0, 0] },
                ],
                ix: 3,
              },
              r: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.227], y: [0.129] },
                    t: 193,
                    s: [0],
                  },
                  { t: 267, s: [360] },
                ],
                ix: 6,
              },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transformer ",
            },
          ],
          nm: "Polystar 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 180,
      op: 300,
      st: 180,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "HalfCircle 2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.854], y: [0.478] },
              o: { x: [0.251], y: [0.459] },
              t: 190,
              s: [0],
            },
            { t: 291, s: [-360] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [208, 122, 0], ix: 2, l: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.166, -0.033],
                    [0, -9.389],
                    [9.389, 0],
                    [-0.001, 8.75],
                  ],
                  o: [
                    [9.389, 0],
                    [0, 9.389],
                    [0.236, 0.059],
                    [0.001, -8.75],
                  ],
                  v: [
                    [0, -17.167],
                    [17, -0.167],
                    [0, 16.833],
                    [-0.005, -0.229],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Tracé 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.117647058824, 0.160784313725, 0.23137254902, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fond 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [-48, 38], ix: 2 },
              a: { a: 0, k: [6, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.25, 0.25], y: [0.619, 0.619] },
                    o: { x: [0.809, 0.809], y: [0.003, 0.003] },
                    t: 191,
                    s: [0, 0],
                  },
                  {
                    i: { x: [0.739, 0.739], y: [-0.788, -0.788] },
                    o: { x: [0.172, 0.172], y: [-2.281, -2.281] },
                    t: 210,
                    s: [199.475, 199.475],
                  },
                  {
                    i: { x: [0.712, 0.712], y: [0.661, 0.661] },
                    o: { x: [0.344, 0.344], y: [0.145, 0.145] },
                    t: 267,
                    s: [176.515, 176.515],
                  },
                  { t: 294, s: [0, 0] },
                ],
                ix: 3,
              },
              r: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 194,
                    s: [0],
                  },
                  { t: 290, s: [-360] },
                ],
                ix: 6,
              },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transformer ",
            },
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 180,
      op: 300,
      st: 180,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "Square 2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.868], y: [0.711] },
              o: { x: [0.161], y: [0.342] },
              t: 199,
              s: [0],
            },
            { t: 286, s: [-360] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [207, 207, 0], ix: 2, l: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [56, 56], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.117647058824, 0.160784313725, 0.23137254902, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [-38, -42], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.373, 0.373], y: [0.837, 0.837] },
                    o: { x: [0.671, 0.671], y: [0, 0] },
                    t: 191,
                    s: [0, 0],
                  },
                  {
                    i: { x: [0.841, 0.841], y: [0.513, 0.513] },
                    o: { x: [0.354, 0.354], y: [-0.821, -0.821] },
                    t: 220,
                    s: [100, 100],
                  },
                  {
                    i: { x: [0.932, 0.932], y: [0.791, 0.791] },
                    o: { x: [0.366, 0.366], y: [0.139, 0.139] },
                    t: 263.424,
                    s: [83.194, 83.194],
                  },
                  { t: 290, s: [0, 0] },
                ],
                ix: 3,
              },
              r: {
                a: 1,
                k: [
                  {
                    i: { x: [0.445], y: [0.773] },
                    o: { x: [0.333], y: [0] },
                    t: 196,
                    s: [0],
                  },
                  { t: 294, s: [720] },
                ],
                ix: 6,
              },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transformer ",
            },
          ],
          nm: "Rectangle 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 180,
      op: 300,
      st: 180,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: "HalfCircle",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.79], y: [0.661] },
              o: { x: [0.279], y: [0.661] },
              t: 15,
              s: [0],
            },
            { t: 111, s: [360] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [128, 192, 0], ix: 2, l: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.166, -0.033],
                    [0, -9.389],
                    [9.389, 0],
                    [-0.001, 8.75],
                  ],
                  o: [
                    [9.389, 0],
                    [0, 9.389],
                    [0.236, 0.059],
                    [0.001, -8.75],
                  ],
                  v: [
                    [0, -17.167],
                    [17, -0.167],
                    [0, 16.833],
                    [-0.005, -0.229],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Tracé 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.117647058824, 0.160784313725, 0.23137254902, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fond 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [32, -32], ix: 2 },
              a: { a: 0, k: [6, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.25, 0.25], y: [0.539, 0.539] },
                    o: { x: [0.809, 0.809], y: [0.004, 0.004] },
                    t: 7,
                    s: [0, 0],
                  },
                  {
                    i: { x: [0.739, 0.739], y: [-0.788, -0.788] },
                    o: { x: [0.172, 0.172], y: [-2.281, -2.281] },
                    t: 30,
                    s: [199.475, 199.475],
                  },
                  {
                    i: { x: [0.712, 0.712], y: [0.661, 0.661] },
                    o: { x: [0.344, 0.344], y: [0.145, 0.145] },
                    t: 87,
                    s: [176.515, 176.515],
                  },
                  { t: 114, s: [0, 0] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transformer ",
            },
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 120,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: "Rectangle",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.917], y: [0.724] },
              o: { x: [0.207], y: [0.597] },
              t: 15,
              s: [0],
            },
            { t: 110, s: [360] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [200, 146, 0], ix: 2, l: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 50, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [50, 50], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.117647058824, 0.160784313725, 0.23137254902, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [-44, 30], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.479, 0.479], y: [0.879, 0.879] },
                    o: { x: [0.033, 0.033], y: [0.178, 0.178] },
                    t: 15,
                    s: [0, 0],
                  },
                  {
                    i: { x: [0.837, 0.837], y: [12.278, 12.278] },
                    o: { x: [0.277, 0.277], y: [22.912, 22.912] },
                    t: 33,
                    s: [116.694, 116.694],
                  },
                  {
                    i: { x: [0.913, 0.913], y: [0.759, 0.759] },
                    o: { x: [0.542, 0.542], y: [0.128, 0.128] },
                    t: 88,
                    s: [116.694, 116.694],
                  },
                  { t: 110, s: [0, 0] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transformer ",
            },
          ],
          nm: "Rectangle 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 120,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: "Square",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.868], y: [0.685] },
              o: { x: [0.161], y: [0.373] },
              t: 19,
              s: [0],
            },
            { t: 114, s: [-360] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [120, 110, 0], ix: 2, l: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [56, 56], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.117647058824, 0.160784313725, 0.23137254902, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [32, 48], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.373, 0.373], y: [0.837, 0.837] },
                    o: { x: [0.671, 0.671], y: [0, 0] },
                    t: 11,
                    s: [0, 0],
                  },
                  {
                    i: { x: [0.841, 0.841], y: [0.513, 0.513] },
                    o: { x: [0.354, 0.354], y: [-0.821, -0.821] },
                    t: 40,
                    s: [100, 100],
                  },
                  {
                    i: { x: [0.932, 0.932], y: [0.76, 0.76] },
                    o: { x: [0.366, 0.366], y: [0.16, 0.16] },
                    t: 83.424,
                    s: [83.194, 83.194],
                  },
                  { t: 114, s: [0, 0] },
                ],
                ix: 3,
              },
              r: {
                a: 1,
                k: [
                  {
                    i: { x: [0.445], y: [0.773] },
                    o: { x: [0.333], y: [0] },
                    t: 16,
                    s: [0],
                  },
                  { t: 114, s: [720] },
                ],
                ix: 6,
              },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transformer ",
            },
          ],
          nm: "Rectangle 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 120,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: "Triangle",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.769], y: [0] },
              t: 9,
              s: [0],
            },
            { t: 120, s: [360] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [202, 217, 0], ix: 2, l: 2 },
        a: { a: 0, k: [-131, 107, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "sr",
              sy: 2,
              d: 1,
              pt: { a: 0, k: 3, ix: 3 },
              p: { a: 0, k: [0, 0], ix: 4 },
              r: { a: 0, k: 90, ix: 5 },
              or: { a: 0, k: 28, ix: 7 },
              os: { a: 0, k: 0, ix: 9 },
              ix: 1,
              nm: "Polystar Path 1",
              mn: "ADBE Vector Shape - Star",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.117647058824, 0.160784313725, 0.23137254902, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [-165.273, 52.906], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.815, 0.815], y: [0.948, 0.948] },
                    o: { x: [0.102, 0.102], y: [0.316, 0.316] },
                    t: 17,
                    s: [0, 0],
                  },
                  {
                    i: { x: [0.847, 0.847], y: [-1.026, -1.026] },
                    o: { x: [0.307, 0.307], y: [-2.711, -2.711] },
                    t: 41,
                    s: [100, 100],
                  },
                  {
                    i: { x: [0.855, 0.855], y: [0.783, 0.783] },
                    o: { x: [0.546, 0.546], y: [0.255, 0.255] },
                    t: 82,
                    s: [94.553, 94.553],
                  },
                  { t: 107, s: [0, 0] },
                ],
                ix: 3,
              },
              r: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667], y: [1] },
                    o: { x: [0.227], y: [0.129] },
                    t: 13,
                    s: [0],
                  },
                  { t: 87, s: [360] },
                ],
                ix: 6,
              },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transformer ",
            },
          ],
          nm: "Polystar 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 120,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 4,
      nm: "Background",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [160, 160, 0], ix: 2, l: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              d: 1,
              ty: "el",
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.986, 0.986], y: [0.953, 0.953] },
                    o: { x: [0.565, 0.565], y: [-0.002, -0.002] },
                    t: 8,
                    s: [1, 1],
                  },
                  {
                    i: { x: [0.678, 0.678], y: [2.443, 2.443] },
                    o: { x: [0.16, 0.16], y: [6.42, 6.42] },
                    t: 18,
                    s: [96, 96],
                  },
                  {
                    i: { x: [0.667, 0.667], y: [0.638, 0.638] },
                    o: { x: [0.234, 0.234], y: [0.823, 0.823] },
                    t: 47,
                    s: [118.686, 118.686],
                  },
                  {
                    i: { x: [0.886, 0.886], y: [0.64, 0.64] },
                    o: { x: [0.558, 0.558], y: [0.203, 0.203] },
                    t: 97,
                    s: [68.984, 68.984],
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                    t: 120,
                    s: [1, 1],
                  },
                  {
                    i: { x: [0.986, 0.986], y: [0.953, 0.953] },
                    o: { x: [0.565, 0.565], y: [-0.002, -0.002] },
                    t: 180,
                    s: [1, 1],
                  },
                  {
                    i: { x: [0.678, 0.678], y: [2.443, 2.443] },
                    o: { x: [0.16, 0.16], y: [6.42, 6.42] },
                    t: 190,
                    s: [96, 96],
                  },
                  {
                    i: { x: [0.667, 0.667], y: [0.638, 0.638] },
                    o: { x: [0.234, 0.234], y: [0.823, 0.823] },
                    t: 219,
                    s: [118.686, 118.686],
                  },
                  {
                    i: { x: [0.886, 0.886], y: [0.64, 0.64] },
                    o: { x: [0.558, 0.558], y: [0.203, 0.203] },
                    t: 269,
                    s: [68.984, 68.984],
                  },
                  { t: 292, s: [1, 1] },
                ],
                ix: 2,
              },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: "Tracé d'ellipse 1",
              mn: "ADBE Vector Shape - Ellipse",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Contour 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.117647058824, 0.160784313725, 0.23137254902, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fond 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 50, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transformer ",
            },
          ],
          nm: "Ellipse 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 375,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};

export default animation;
